import html from 'text!modules/jquery.elargirRechercheSelectorTemplate.html';
import $ from 'jquery';
import 'jquery-ui/ui/unique-id';

function elargirRechercheSelector($elargirRechercheSelector, customOptions) {
  const RECHERCHE_VILLE = 'ville',
    RECHERCHE_DEPARTEMENT = 'departement';

  let options = {
    onInit: function(selectedItems) {},
    onItemsSelected: function(selectedItems) {},
    availableItems: [],
    selectedItems: [],
    type: ''
  };

  if (customOptions) {
    $.extend(options, customOptions);
  } else {
    options.availableItems = [];
    options.selectedItems = [];
    options.type = '';
  }

  $elargirRechercheSelector.html(html);
  const $container = $elargirRechercheSelector.find('.elargir-recherche-selector').first();
  const cancelButton = $('.js-cancelling-elargir-recherche');
  const selectedItems = options.selectedItems.slice(0);
  const availableItems = options.availableItems.slice(0);

  if (options.type !== null && options.type === RECHERCHE_VILLE) {
    renderSelectorDistanceKilometrique(
      selectedItems,
      availableItems,
      $container,
      options.onItemsSelected
    );
  } else if (options.type !== null && options.type === RECHERCHE_DEPARTEMENT) {
    renderSelectorDepartementsVoisins(
      selectedItems,
      availableItems,
      $container,
      options.onItemsSelected
    );
  }

  options.onInit(selectedItems);

  cancelButton.click(function() {
    options.selectedItems = [];

    $('.js-elargir-recherche-selector').removeClass('toggled');
  });

  function renderSelectorDistanceKilometrique(
    selectedItems,
    availableItems,
    container,
    onItemsSelected
  ) {
    container.uniqueId();
    const uniqueId = container.attr('id');

    container.prepend(
      '<div class="row">' +
        '   <div class="col-xs-12">' +
        '       <span class="section-title">&Eacute;largir &agrave; la distance kilom&eacute;trique</span>' +
        '       <hr />' +
        '   </div>' +
        '</div>' +
        '<div class="side-padded row">' +
        '   <div class="col-xs-12 rayon-recherche-container">' +
        '       <span class="rayon-recherche-title">Rayon de recherche</span>' +
        '   </div>' +
        '</div>' +
        '<div class="row">' +
        '   <div class="col-xs-12">' +
        '       <div class="distance-kilometrique-displayer js-displayer-kilometrique">' +
        '       </div>' +
        '   </div>' +
        '</div>'
    );

    $.each(availableItems, function(i, item) {
      $('.js-displayer-kilometrique').append(
        '<div id="' +
          uniqueId +
          '-' +
          item +
          '" class="' +
          'distance-container ' +
          (isDistanceSelected(item) ? 'actif' : '') +
          '">' +
          '   <span id="' +
          item +
          '">' +
          (item === 0 ? 'Lieu exact' : item + 'km') +
          '</span>' +
          '</div>'
      );
    });

    $elargirRechercheSelector.find('.distance-container').click(function() {
      selectedItems = [];
      const $currentDistance = $(this);
      const distanceId = parseInt($currentDistance.children().attr('id'));

      $currentDistance.siblings().removeClass('actif');

      if ($currentDistance.hasClass('actif')) {
        $currentDistance.removeClass('actif');
        selectedItems.splice(0, 1);
      } else {
        $currentDistance.addClass('actif');
        selectedItems.push(distanceId);
      }
      onItemsSelected(selectedItems);
    });
  }

  function renderSelectorDepartementsVoisins(
    selectedItems,
    availableItems,
    container,
    onItemsSelected
  ) {
    container.uniqueId();
    const uniqueId = container.attr('id');

    container.prepend(
      '<div class="row">' +
        '   <div class="col-xs-12">' +
        '       <span class="section-title">&Eacute;largir aux d&eacute;partements voisins</span>' +
        '       <hr/>' +
        '   </div>' +
        '</div>' +
        '<div class="row">' +
        '   <div class="col-xs-12">' +
        '       <div class="localisation-dropdown-selector">' +
        '           <div class="multi-selector-item js-main-multi-selector-item">' +
        '               <input class="multi-checkbox" data-code="100" type="checkbox" id="' +
        uniqueId +
        '-all' +
        '"/>' +
        '               <div class="label-wrapper">' +
        '                   <label for="' +
        uniqueId +
        '-all' +
        '">' +
        '                       <span class="visible-checkbox icon-checkmark" data-code=""></span>' +
        '                       <span class="item-label">Tous les d&eacute;partements voisins</span>' +
        '                   </label>' +
        '               </div>' +
        '           </div>' +
        '       </div>' +
        '   </div>' +
        '</div>'
    );

    $.each(availableItems, function(i, item) {
      $('.localisation-dropdown-selector').append(
        '<div class="multi-selector-item sub-multi-selector-item">' +
          '   <input class="multi-checkbox" data-code="' +
          item.code +
          '" type="checkbox" value="' +
          item.label +
          '" ' +
          (isDepartementSelected(item) ? 'checked' : '') +
          ' id="' +
          uniqueId +
          '-' +
          item.code +
          '"/>' +
          '      <div class="label-wrapper">' +
          '          <label for="' +
          uniqueId +
          '-' +
          item.code +
          '">' +
          '              <span class="visible-checkbox icon-checkmark" data-code="' +
          item.code +
          '"></span>' +
          '              <span class="item-label">' +
          item.label +
          ' (' +
          item.code +
          ')' +
          '</span>' +
          '          </label>' +
          '      </div>' +
          '</div>'
      );
    });

    const allCheckboxes = $container.find('input[type="checkbox"]');
    const allDepartmentCheckboxes = getAllDepartmentCheckboxes(allCheckboxes);

    if (isAllCheckboxesAreChecked(allDepartmentCheckboxes)) {
      tickCheckboxByDepartmentcode(100);
    }

    $elargirRechercheSelector.find('.multi-checkbox').change(function() {
      const $currentCheckbox = $(this);
      const checkboxCode = $currentCheckbox.attr('data-code');

      if (isCheckboxAll($currentCheckbox)) {
        if (isCodeChecked(checkboxCode)) {
          allCheckboxes.prop('checked', true);
          selectedItems = addAllItemToSelectedItems(availableItems, allDepartmentCheckboxes);
        } else {
          allCheckboxes.prop('checked', false);
          selectedItems = [];
        }
      } else {
        if (isCodeChecked($currentCheckbox.attr('data-code'))) {
          selectedItems = addItem($currentCheckbox, availableItems, selectedItems);
          if (isAllCheckboxesAreChecked(allDepartmentCheckboxes)) {
            tickCheckboxByDepartmentcode(100);
          }
        } else {
          selectedItems = removeItem($currentCheckbox, selectedItems);
          if (!isAllCheckboxesAreChecked(allDepartmentCheckboxes)) {
            untickCheckboxByDepartmentcode(100);
          }
        }
      }
      onItemsSelected(selectedItems);
    });
  }

  function isDistanceSelected(item) {
    let currentDistance = selectedItems[0];
    return currentDistance !== null && currentDistance !== undefined
      ? currentDistance === item
      : item === 20;
  }

  function isDepartementSelected(item) {
    return (
      selectedItems.findIndex(function(selectedItem) {
        return item.code === selectedItem.code;
      }) !== -1
    );
  }

  function getAllDepartmentCheckboxes(allCheckboxes) {
    return allCheckboxes.slice(1);
  }

  function isAllCheckboxesAreChecked(allDepartmentCheckboxes) {
    return (
      allDepartmentCheckboxes.filter(function(i, item) {
        return isCodeChecked(item.getAttribute('data-code'));
      }).length === allDepartmentCheckboxes.length
    );
  }

  function isCheckboxAll(checkbox) {
    return checkbox.attr('data-code') === '100';
  }

  function isCodeChecked(departmentCode) {
    return $container.find("input[data-code='" + departmentCode + "']").prop('checked');
  }

  function tickCheckboxByDepartmentcode(departmentCode) {
    $container.find("input[data-code='" + departmentCode + "']").prop('checked', true);
  }

  function untickCheckboxByDepartmentcode(departmentCode) {
    $container.find("input[data-code='" + departmentCode + "']").prop('checked', false);
  }

  function addAllItemToSelectedItems(availableItems, allCheckboxes) {
    let newSelectedItems = [];
    $.each(availableItems, function(i, item) {
      $.each(allCheckboxes, function(index, value) {
        if (item.label === value.value && newSelectedItems.indexOf(item) === -1) {
          newSelectedItems.push(item);
        }
      });
    });
    return newSelectedItems;
  }

  function addItem(addedItem, availableItems, selectedItems) {
    $.each(availableItems, function(i, item) {
      if (item.label === addedItem.attr('value') && selectedItems.indexOf(item) === -1) {
        selectedItems.push(item);
      }
    });
    return selectedItems;
  }

  function removeItem(deletedItem, selectedItems) {
    return selectedItems.filter(item => item.code !== deletedItem.attr('data-code'));
  }
}

// exposition sous forme de module jQuery
$.fn.extend({
  elargirRechercheSelector: function(customOptions) {
    return this.each(function() {
      elargirRechercheSelector($(this), customOptions);
    });
  }
});
export default elargirRechercheSelector;
